import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Highlighter from "react-highlight-words"
import cc from "classcat"
import useTranslations from "hooks/useTranslations"
import Divided from "components/organisms/common/Divided"

const InfoImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      harrassment: file(
        relativePath: { eq: "courses/AdobeStock_323148051.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 600)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(images.harrassment)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "center",
      }}
      className={className}
      alt=""
    />
  )
}

const Text = ({ className = "", children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left font-display text-3xl text-zinc-800 sm:text-4xl",
      className,
    ])}
  >
    {children}
  </p>
)

const SmallText = ({ className = "", children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left text-lg text-zinc-100",
      className,
    ])}
  >
    {children}
  </p>
)

const Title = ({ text, highlight }) => {
  return (
    <Text>
      <Highlighter
        highlightClassName="text-kkm-green bg-transparent"
        searchWords={highlight || []}
        autoEscape
        textToHighlight={text}
        className="text-zinc-100"
      />
    </Text>
  )
}

export default () => {
  const {
    proCoursesInfo1Title,
    proCoursesInfo1Highlights,
    proCoursesInfo1Description1,
    proCoursesInfo1Description2,
  } = useTranslations()
  return (
    <Divided
      Image={InfoImage}
      title={
        <Title
          text={proCoursesInfo1Title}
          highlight={proCoursesInfo1Highlights}
        />
      }
      theme="dark"
      reversed
    >
      <div className="space-y-6">
        <SmallText>{proCoursesInfo1Description1}</SmallText>
        <SmallText>{proCoursesInfo1Description2}</SmallText>
      </div>
    </Divided>
  )
}
